module.exports = __webpack_public_path__ + "resources/img/sp_solution_m.7bbf2823936541c44ce6ce3c591cb5b6.png";